import React from "react";
import {Card} from "antd";
import {Route, Router, Switch} from "react-router-dom";
import {connect} from "react-redux";

import {AuthActions, TranslationContexts} from "../Redux";
import {history, routerPath} from "../Config";
import {
    AllKYCContainer,
    IndexContainer,
    KycApplication,
    KycApplicationsSettings,
    LoginContainer,
    MainSmeContainer
} from "../Containers";
import {checkJsonProp, TranslationsInit} from "../Utilities";
import {
    CallbackPage,
    Content404,
    PrivateRoute,
    PrivateRouteNew,
    SilentRenew
} from "../Components";
import {PartContent, PartTop} from "../PageParts";

import {library} from "@fortawesome/fontawesome-svg-core";
import {far} from "@fortawesome/free-regular-svg-icons";
import jwtDecode from "jwt-decode";
import {WaitingRoom} from "../Containers/WaitingRoom/WaitingRoom";
import {StepperRouter} from "@routes/StepperRouter";
import {i18, trb} from "@utilities";

library.add(far);

class App extends React.Component {
    componentDidMount = () => {
        setInterval(this.checkToken, 60000);
    };
    
    checkToken = () => {
        const user = JSON.parse(sessionStorage.getItem("user")),
            {dispatch} = this.props;
        
        if (user) {
            const token = checkJsonProp(user, "token"),
                tokenDecode = jwtDecode(token),
                exp = tokenDecode.exp * 1000,
                now = new Date().getTime(),
                refreshToken = checkJsonProp(user, "refreshToken");
            
            if (now > exp) {
                dispatch(AuthActions.refreshToken(refreshToken));
            }
        }
    };
    
    render() {
        const containerWithCard = Component => (
                <div className="main_content">
                    <div className="main_inner py-3 py-md-5">
                        <PartContent>
                            <Component/>
                        </PartContent>
                    </div>
                </div>
            ),
            containerWithoutCard = Component => (
                <div className="main_content">
                    <div className="main_inner py-3 py-md-5">
                        <Component/>
                    </div>
                </div>
            );
        
        const {translations} = this.props;
        return (
            <>
                <TranslationsInit context={TranslationContexts.KYCOnBoarding}/>
                <TranslationsInit context={TranslationContexts.classificators}/>
                <div className="eb_print_none sme" id="eb_print_none">
                    <PartTop withLanguage/>
                    {translations?.length > 1 && (
                        <Router history={history}>
                            <Switch>
                                <PrivateRouteNew
                                    path={routerPath.kyc}
                                    exact
                                    component={() => containerWithoutCard(MainSmeContainer)}
                                />
                                <PrivateRoute
                                    path={routerPath.listKyc}
                                    exact
                                    component={() => containerWithoutCard(AllKYCContainer)}
                                />
                                <PrivateRoute
                                    path={routerPath.kycApplicationsSettings}
                                    exact
                                    component={() => containerWithoutCard(KycApplicationsSettings)}
                                />
                                <PrivateRoute
                                    path={routerPath.kycApplication}
                                    exact
                                    component={() => containerWithoutCard(KycApplication)}
                                />
                                <Route
                                    exact
                                    path={routerPath.silentRenew}
                                    component={() => containerWithCard(SilentRenew)}
                                />
                                <Route
                                    exact
                                    path={routerPath.callback}
                                    component={() => containerWithCard(CallbackPage)}
                                />
                                <Route
                                    exact
                                    path={routerPath.login}
                                    component={() => containerWithCard(LoginContainer)}
                                />
                                <Route exact path={routerPath.waitingRoom} component={WaitingRoom}/>
                                <Route
                                    exact
                                    path={routerPath.index}
                                    component={() => containerWithCard(IndexContainer)}
                                />
                                <StepperRouter/>
                                <Route component={Content404}/>
                            </Switch>
                        </Router>
                    )}
                    <div className="text-center p-3">
                        {trb(i18.Labels.FooterCopyright, {yyyy: new Date().getFullYear()})}
                    </div>
                </div>
            </>
        );
    }
}

function mapStateToProps(state) {
    const {language} = state.languageReducer;
    const {translations} = state.translationReducer;
    
    return {
        language,
        translations
    };
}

const connectedApp = connect(mapStateToProps)(App);
export {connectedApp as App};
